export type Locale = "es" | "en";
// ─── Spanish dictionary ─────────────────────────────────────
const es: Record<string, string> = {
  // Navbar
  "nav.home": "Inicio",
  "nav.blog": "Blog",
  "nav.ideas": "Ideas de Lectores",
  "nav.about": "Sobre el Libro",
  "nav.admin": "Admin",
  "nav.buyBook": "Comprar Libro",
  "nav.logout": "Salir",

  // Brand
  "brand.name": "Garantías",
  "brand.sub": "Extraordinarias",

  // Home Hero
  "home.badge": "Nuevo libro de negocios",
  "home.title1": "Convierte tus garantías en tu",
  "home.titleHighlight": "ventaja injusta",
  "home.desc": "te muestra cómo usar promesas disruptivas para vender más, fidelizar clientes y dejar de competir por precio. 100 ideas listas para adaptar a tu negocio.",
  "home.descBold": "Garantías Extraordinarias",
  "home.ctaBuy": "Comprar el Libro",
  "home.ctaExplore": "Explorar Garantías",

  // Home Features
  "home.featuresTitle": "¿Qué encontrarás aquí?",
  "home.featuresDesc": "Este sitio es la extensión viva del libro. Nuevas garantías, ideas de la comunidad y recursos para transformar tu negocio.",
  "home.feat1Title": "Blog de Garantías",
  "home.feat1Desc": "Nuevas ideas de garantías extraordinarias publicadas por Edmundo Treviño, organizadas por industria y categoría.",
  "home.feat1Link": "Ver blog",
  "home.feat2Title": "Ideas de Lectores",
  "home.feat2Desc": "La comunidad comparte sus propias garantías extraordinarias. Envía tu idea y forma parte del movimiento.",
  "home.feat2Link": "Ver ideas",
  "home.feat3Title": "Asesoría Privada",
  "home.feat3Desc": "Trabaja directamente con Edmundo Treviño para diseñar garantías extraordinarias para tu negocio.",
  "home.feat3Link": "Agendar asesoría",

  // Home Latest
  "home.latestBlog": "Últimas Garantías del Blog",
  "home.viewAll": "Ver todas",
  "home.communityIdeas": "Ideas de la Comunidad",

  // Home CTA
  "home.ctaTitle1": "¿Listo para crear tu",
  "home.ctaTitle2": "ventaja injusta",
  "home.ctaDesc": "Adquiere el libro, agenda una asesoría privada con Edmundo Treviño, o comparte tu propia idea de garantía extraordinaria.",
  "home.ctaSendIdea": "Enviar mi Idea",

  // Blog
  "blog.badge": "Blog",
  "blog.title": "Garantías",
  "blog.titleHighlight": "Extraordinarias",
  "blog.desc": "Nuevas ideas de garantías publicadas por Edmundo Treviño. Descubre cómo empresas reales usan promesas disruptivas para diferenciarse.",
  "blog.comingSoon": "Próximamente",
  "blog.comingSoonDesc": "Las primeras garantías del blog se publicarán muy pronto. ¡Vuelve a visitarnos!",
  "blog.byAuthor": "Por Edmundo Treviño",

  // BlogPost
  "blogPost.notFound": "Publicación no encontrada",
  "blogPost.backToBlog": "Volver al Blog",
  "blogPost.sharePrompt": "¿Te resultó útil? Comparte esta garantía con tu red.",
  "blogPost.share": "Compartir:",
  "blogPost.copyLink": "Copiar enlace",
  "blogPost.copied": "¡Copiado!",
  "blogPost.linkCopied": "Enlace copiado al portapapeles",
  "blogPost.linkCopyError": "No se pudo copiar el enlace",
  "blogPost.ctaLiked": "¿Te gustó esta garantía? Descubre 100 ideas más en el libro.",
  "blogPost.ctaBuy": "Comprar Garantías Extraordinarias",

  // Comments
  "comments.title": "Comentarios",
  "comments.leaveComment": "Deja tu comentario",
  "comments.name": "Tu nombre *",
  "comments.namePlaceholder": "Ej: María García",
  "comments.email": "Email (opcional, no se publica)",
  "comments.emailPlaceholder": "tu@email.com",
  "comments.comment": "Comentario *",
  "comments.commentPlaceholder": "¿Qué opinas de esta garantía? ¿Cómo la aplicarías en tu negocio?",
  "comments.submit": "Publicar Comentario",
  "comments.submitting": "Publicando...",
  "comments.success": "¡Comentario publicado! Gracias por participar en la discusión.",
  "comments.error": "Error al publicar tu comentario. Intenta de nuevo.",
  "comments.empty": "Aún no hay comentarios. ¡Sé el primero en compartir tu opinión!",
  "comments.nameRequired": "Por favor ingresa tu nombre.",
  "comments.tooShort": "El comentario debe tener al menos 3 caracteres.",

  // Ideas
  "ideas.badge": "Comunidad",
  "ideas.title1": "Ideas de mis",
  "ideas.titleHighlight": "Lectores",
  "ideas.desc": "¿Tienes una idea de garantía extraordinaria? Compártela con la comunidad. Las mejores ideas serán publicadas aquí.",
  "ideas.formTitle": "Envía tu Garantía",
  "ideas.name": "Tu nombre *",
  "ideas.namePlaceholder": "Ej: María García",
  "ideas.email": "Email (opcional)",
  "ideas.guaranteeTitle": "Título de la garantía *",
  "ideas.guaranteeTitlePlaceholder": "Ej: \"Si no llegas a tiempo, tu siguiente servicio es gratis\"",
  "ideas.description": "Descripción *",
  "ideas.descriptionPlaceholder": "Describe tu idea de garantía, para qué tipo de negocio aplica y por qué sería extraordinaria...",
  "ideas.industry": "Industria (opcional)",
  "ideas.industryPlaceholder": "Selecciona una industria",
  "ideas.submit": "Enviar mi Idea",
  "ideas.submitting": "Enviando...",
  "ideas.success": "¡Gracias por tu idea! Será revisada y publicada pronto.",
  "ideas.error": "Error al enviar tu idea. Intenta de nuevo.",
  "ideas.submitted": "¡Idea enviada!",
  "ideas.submittedDesc": "Tu garantía será revisada por Edmundo y publicada pronto.",
  "ideas.sendAnother": "Enviar otra idea",
  "ideas.approved": "Ideas Aprobadas",
  "ideas.beFirst": "Sé el primero",
  "ideas.beFirstDesc": "Aún no hay ideas publicadas. ¡Envía la tuya y sé el primero en aparecer aquí!",
  "ideas.nameRequired": "Por favor ingresa tu nombre.",
  "ideas.titleRequired": "Por favor ingresa un título para tu garantía.",
  "ideas.descTooShort": "La descripción debe tener al menos 10 caracteres.",

  // About the Book
  "about.badge": "Sobre el Libro",
  "about.title1": "¿Qué hace",
  "about.titleHighlight": "extraordinaria",
  "about.title2": "a una garantía?",
  "about.desc": "Este libro nace de más de 20 años implementando garantías atrevidas en negocios reales: talleres, distribuidores, marcas de autopartes, empresas de servicios y modelos de franquicia.",
  "about.ctaBuy": "Comprar el Libro",
  "about.ctaMentoring": "Agendar Asesoría",
  "about.benefitsTitle": "¿Qué vas a encontrar en el libro?",
  "about.b1Title": "Deja de competir por precio",
  "about.b1Desc": "Usa garantías como herramienta de diferenciación y branding.",
  "about.b2Title": "100 ejemplos aplicables",
  "about.b2Desc": "Productos, servicios, membresías, educación, salud, hospitalidad, tecnología y más.",
  "about.b3Title": "Mejora tus procesos internos",
  "about.b3Desc": "Las garantías bien diseñadas obligan a tu equipo a ser más eficiente y confiable.",
  "about.b4Title": "Fideliza y sorprende clientes",
  "about.b4Desc": "Convierte reclamaciones en historias de marketing y recomendación orgánica.",
  "about.audienceTitle": "¿Para quién es este libro?",
  "about.aud1": "Dueños de negocio",
  "about.aud2": "Directores y gerentes comerciales",
  "about.aud3": "Líderes de equipos de ventas",
  "about.aud4": "Coaches y consultores",
  "about.aud5": "Franquiciantes",
  "about.aud6": "Emprendedores",
  "about.audienceDesc": "Si diriges una empresa, eres consultor, franquiciante, dueño de taller, clínica, restaurante, agencia, e-commerce o vendes servicios profesionales, este libro te ayudará a crear tu propio \"monopolio temporal\" en tu mercado.",
  "about.authorTitle1": "¿Quién es",
  "about.authorTitle2": "Edmundo Treviño",
  "about.authorTag1": "Empresario binacional",
  "about.authorTag2": "Mentor de inversionistas",
  "about.authorTag3": "Fundador de Comprando América",
  "about.authorBio1": "Edmundo Treviño es empresario, autor y mentor. Ha fundado y dirigido múltiples compañías en Estados Unidos y México en sectores como servicio automotriz, distribución, comercio internacional y consultoría para inversionistas latinos.",
  "about.authorBio2": "A lo largo de más de dos décadas ha utilizado garantías extraordinarias para diferenciar sus empresas, mejorar procesos internos, elevar la autoestima de sus equipos y generar crecimiento sostenido en mercados altamente competidos.",
  "about.authorCta": "Agendar Mentoría con Edmundo",
  "about.detailsTitle": "Detalles del Libro",
  "about.detailAuthor": "Autor",
  "about.detailFormat": "Formato",
  "about.detailFormatVal": "Libro físico impreso",
  "about.detailShipping": "Envío",
  "about.detailShippingVal": "Gratis a México y USA",
  "about.detailQuote": "\"Garantía de coherencia: Sería muy raro que un libro sobre garantías extraordinarias no se comprometiera contigo. Si después de leer el libro sientes que no te dio al menos una idea clara de garantía para tu negocio, trabajaremos contigo para sugerirte directamente una propuesta aplicable a tu empresa.\"",
  "about.detailCta": "Quiero mi Ejemplar",

  // Opciones para ti y tu equipo (purchase cards)
  "options.title": "Opciones para ti y tu equipo",
  "options.bestseller": "BESTSELLER",
  "options.amazonNote": "También disponible en",
  "options.bookCard.label": "Libro Físico",
  "options.bookCard.subtitle": "Inversión única",
  "options.bookCard.b1": "1 ejemplar físico del libro",
  "options.bookCard.b2": "Envío gratis a México y Estados Unidos",
  "options.bookCard.b3": "100 ejemplos de garantías",
  "options.bookCard.b4": "Lectura práctica y directa",
  "options.bookCard.cta": "Comprar Libro",
  "options.mentoringCard.badge": "RECOMENDADO",
  "options.mentoringCard.label": "Mentoría 1:1",
  "options.mentoringCard.subtitle": "Sesión estratégica",
  "options.mentoringCard.b1": "45 minutos con Edmundo Treviño",
  "options.mentoringCard.b2": "Diagnóstico de tu negocio",
  "options.mentoringCard.b3": "Diseño de 1-3 garantías",
  "options.mentoringCard.b4": "Grabación opcional",
  "options.mentoringCard.cta": "Reservar Mentoría",
  "options.bundleCard.label": "Paquete 25 Libros + Mentoría",
  "options.bundleCard.subtitle": "Para equipos",
  "options.bundleCard.b1": "25 ejemplares físicos",
  "options.bundleCard.b2": "Mentoría/conferencia estratégica",
  "options.bundleCard.b3": "Trabajo sobre casos reales",
  "options.bundleCard.b4": "Q&A con tu equipo",
  "options.bundleCard.cta": "Adquirir Paquete",
  "options.bundleCard.whatsappMessage": "Hola, me interesa adquirir un paquete corporativo de libros y asesoría para mi empresa.",

  // Newsletter
  "newsletter.badge": "Newsletter de Edmundo Treviño",
  "newsletter.title": "Recibe nuevas garantías y oportunidades de negocio",
  "newsletter.desc": "Suscríbete para recibir cada nueva garantía extraordinaria, ideas de negocios en USA y oportunidades de inversión directamente en tu correo.",
  "newsletter.namePlaceholder": "Tu nombre (opcional)",
  "newsletter.emailPlaceholder": "tu@email.com",
  "newsletter.submit": "Suscribirme",
  "newsletter.noSpam": "Sin spam. Puedes cancelar en cualquier momento.",
  "newsletter.success": "¡Listo! Revisa tu correo para confirmar tu suscripción.",
  "newsletter.alreadySubscribed": "Ya estás suscrito. ¡Gracias por tu interés!",
  "newsletter.reactivated": "¡Bienvenido de vuelta! Tu suscripción ha sido reactivada.",
  "newsletter.subscribeSuccess": "¡Suscripción exitosa! Recibirás nuestras próximas publicaciones.",
  "newsletter.subscribeError": "Error al suscribirte. Intenta de nuevo.",
  "newsletter.emailRequired": "Por favor ingresa tu email.",
  "newsletter.subscribed": "¡Suscrito!",
  "newsletter.inlineTitle": "No te pierdas ninguna garantía",
  "newsletter.inlineDesc": "Recibe nuevas garantías extraordinarias, ideas de negocios en USA y oportunidades de inversión.",
  "newsletter.inlineSuccess": "¡Suscripción exitosa!",
  "newsletter.compactTitle": "Newsletter",
  "newsletter.compactDesc": "Garantías, negocios en USA e inversión.",

  // Footer
  "footer.brand": "Garantías Extraordinarias",
  "footer.brandDesc": "100 ideas de garantías para diferenciar tu empresa. Un proyecto de Edmundo Treviño.",
  "footer.navigation": "Navegación",
  "footer.edmundo": "Edmundo Treviño",
  "footer.personalSite": "Sitio Personal",
  "footer.buyBook": "Comprar el Libro",
  "footer.bookConsulting": "Agendar Asesoría",
  "footer.copyright": "Garantías Extraordinarias por Edmundo Treviño. Todos los derechos reservados.",

  // Admin
  "admin.title": "Panel de Administración",
  "admin.desc": "Gestiona el blog y modera las ideas de los lectores.",
  "admin.restricted": "Acceso Restringido",
  "admin.restrictedDesc": "Inicia sesión como administrador para acceder al panel.",
  "admin.login": "Iniciar Sesión",
  "admin.noPermission": "Sin Permisos",
  "admin.noPermissionDesc": "No tienes permisos de administrador.",
  "admin.tabBlog": "Blog",
  "admin.tabIdeas": "Ideas de Lectores",
  "admin.tabSubscribers": "Suscriptores",

  // Industries (for display)
  "industry.automotive": "Automotriz",
  "industry.restaurants": "Restaurantes y Hospitalidad",
  "industry.health": "Salud y Clínicas",
  "industry.education": "Educación",
  "industry.technology": "Tecnología",
  "industry.ecommerce": "E-commerce",
  "industry.professional": "Servicios Profesionales",
  "industry.franchises": "Franquicias",
  "industry.construction": "Construcción",
  "industry.retail": "Retail / Comercio",
  "industry.memberships": "Membresías",
  "industry.consulting": "Consultoría",
  "industry.other": "Otro",

  // 404
  "notFound.title": "Página no encontrada",
  "notFound.desc": "La página que buscas no existe.",
  "notFound.home": "Volver al inicio",
};

// ─── English dictionary ─────────────────────────────────────
const en: Record<string, string> = {
  // Navbar
  "nav.home": "Home",
  "nav.blog": "Blog",
  "nav.ideas": "Reader Ideas",
  "nav.about": "About the Book",
  "nav.admin": "Admin",
  "nav.buyBook": "Buy the Book",
  "nav.logout": "Log out",

  // Brand
  "brand.name": "Extraordinary",
  "brand.sub": "Warranties",

  // Home Hero
  "home.badge": "New business book",
  "home.title1": "Turn your warranties into your",
  "home.titleHighlight": "unfair advantage",
  "home.desc": "shows you how to use disruptive promises to sell more, build customer loyalty, and stop competing on price. 100 ready-to-use ideas to adapt to your business.",
  "home.descBold": "Extraordinary Warranties",
  "home.ctaBuy": "Buy the Book",
  "home.ctaExplore": "Explore Warranties",

  // Home Features
  "home.featuresTitle": "What will you find here?",
  "home.featuresDesc": "This site is the living extension of the book. New warranties, community ideas, and resources to transform your business.",
  "home.feat1Title": "Warranty Blog",
  "home.feat1Desc": "New extraordinary warranty ideas published by Edmundo Treviño, organized by industry and category.",
  "home.feat1Link": "View blog",
  "home.feat2Title": "Reader Ideas",
  "home.feat2Desc": "The community shares their own extraordinary warranties. Submit your idea and be part of the movement.",
  "home.feat2Link": "View ideas",
  "home.feat3Title": "Private Consulting",
  "home.feat3Desc": "Work directly with Edmundo Treviño to design extraordinary warranties for your business.",
  "home.feat3Link": "Book a session",

  // Home Latest
  "home.latestBlog": "Latest Blog Warranties",
  "home.viewAll": "View all",
  "home.communityIdeas": "Community Ideas",

  // Home CTA
  "home.ctaTitle1": "Ready to create your",
  "home.ctaTitle2": "unfair advantage",
  "home.ctaDesc": "Get the book, schedule a private consulting session with Edmundo Treviño, or share your own extraordinary warranty idea.",
  "home.ctaSendIdea": "Submit my Idea",

  // Blog
  "blog.badge": "Blog",
  "blog.title": "Extraordinary",
  "blog.titleHighlight": "Warranties",
  "blog.desc": "New warranty ideas published by Edmundo Treviño. Discover how real businesses use disruptive promises to stand out.",
  "blog.comingSoon": "Coming Soon",
  "blog.comingSoonDesc": "The first blog warranties will be published very soon. Stay tuned!",
  "blog.byAuthor": "By Edmundo Treviño",

  // BlogPost
  "blogPost.notFound": "Post not found",
  "blogPost.backToBlog": "Back to Blog",
  "blogPost.sharePrompt": "Found this useful? Share this warranty with your network.",
  "blogPost.share": "Share:",
  "blogPost.copyLink": "Copy link",
  "blogPost.copied": "Copied!",
  "blogPost.linkCopied": "Link copied to clipboard",
  "blogPost.linkCopyError": "Could not copy the link",
  "blogPost.ctaLiked": "Liked this warranty? Discover 100 more ideas in the book.",
  "blogPost.ctaBuy": "Buy Extraordinary Warranties",

  // Comments
  "comments.title": "Comments",
  "comments.leaveComment": "Leave a comment",
  "comments.name": "Your name *",
  "comments.namePlaceholder": "e.g. John Smith",
  "comments.email": "Email (optional, not published)",
  "comments.emailPlaceholder": "you@email.com",
  "comments.comment": "Comment *",
  "comments.commentPlaceholder": "What do you think about this warranty? How would you apply it in your business?",
  "comments.submit": "Post Comment",
  "comments.submitting": "Posting...",
  "comments.success": "Comment posted! Thanks for joining the discussion.",
  "comments.error": "Error posting your comment. Please try again.",
  "comments.empty": "No comments yet. Be the first to share your thoughts!",
  "comments.nameRequired": "Please enter your name.",
  "comments.tooShort": "The comment must be at least 3 characters.",

  // Ideas
  "ideas.badge": "Community",
  "ideas.title1": "Ideas from my",
  "ideas.titleHighlight": "Readers",
  "ideas.desc": "Do you have an extraordinary warranty idea? Share it with the community. The best ideas will be published here.",
  "ideas.formTitle": "Submit your Warranty",
  "ideas.name": "Your name *",
  "ideas.namePlaceholder": "e.g. John Smith",
  "ideas.email": "Email (optional)",
  "ideas.guaranteeTitle": "Warranty title *",
  "ideas.guaranteeTitlePlaceholder": "e.g. \"If we're not on time, your next service is free\"",
  "ideas.description": "Description *",
  "ideas.descriptionPlaceholder": "Describe your warranty idea, what type of business it applies to, and why it would be extraordinary...",
  "ideas.industry": "Industry (optional)",
  "ideas.industryPlaceholder": "Select an industry",
  "ideas.submit": "Submit my Idea",
  "ideas.submitting": "Submitting...",
  "ideas.success": "Thank you for your idea! It will be reviewed and published soon.",
  "ideas.error": "Error submitting your idea. Please try again.",
  "ideas.submitted": "Idea submitted!",
  "ideas.submittedDesc": "Your warranty will be reviewed by Edmundo and published soon.",
  "ideas.sendAnother": "Submit another idea",
  "ideas.approved": "Approved Ideas",
  "ideas.beFirst": "Be the first",
  "ideas.beFirstDesc": "No ideas published yet. Submit yours and be the first to appear here!",
  "ideas.nameRequired": "Please enter your name.",
  "ideas.titleRequired": "Please enter a title for your warranty.",
  "ideas.descTooShort": "The description must be at least 10 characters.",

  // About the Book
  "about.badge": "About the Book",
  "about.title1": "What makes a warranty",
  "about.titleHighlight": "extraordinary",
  "about.title2": "?",
  "about.desc": "This book is born from over 20 years of implementing bold warranties in real businesses: auto shops, distributors, auto parts brands, service companies, and franchise models.",
  "about.ctaBuy": "Buy the Book",
  "about.ctaMentoring": "Book a Session",
  "about.benefitsTitle": "What will you find in the book?",
  "about.b1Title": "Stop competing on price",
  "about.b1Desc": "Use warranties as a differentiation and branding tool.",
  "about.b2Title": "100 applicable examples",
  "about.b2Desc": "Products, services, memberships, education, health, hospitality, technology, and more.",
  "about.b3Title": "Improve your internal processes",
  "about.b3Desc": "Well-designed warranties force your team to be more efficient and reliable.",
  "about.b4Title": "Build loyalty and surprise clients",
  "about.b4Desc": "Turn complaints into marketing stories and organic referrals.",
  "about.audienceTitle": "Who is this book for?",
  "about.aud1": "Business owners",
  "about.aud2": "Sales directors and managers",
  "about.aud3": "Sales team leaders",
  "about.aud4": "Coaches and consultants",
  "about.aud5": "Franchisors",
  "about.aud6": "Entrepreneurs",
  "about.audienceDesc": "If you run a business, are a consultant, franchisor, shop owner, clinic, restaurant, agency, e-commerce, or sell professional services, this book will help you create your own \"temporary monopoly\" in your market.",
  "about.authorTitle1": "Who is",
  "about.authorTitle2": "Edmundo Treviño",
  "about.authorTag1": "Binational entrepreneur",
  "about.authorTag2": "Investor mentor",
  "about.authorTag3": "Founder of Comprando América",
  "about.authorBio1": "Edmundo Treviño is an entrepreneur, author, and mentor. He has founded and led multiple companies in the United States and Mexico in sectors such as automotive service, distribution, international trade, and consulting for Latin investors.",
  "about.authorBio2": "Over more than two decades, he has used extraordinary warranties to differentiate his companies, improve internal processes, boost team morale, and generate sustained growth in highly competitive markets.",
  "about.authorCta": "Book Mentoring with Edmundo",
  "about.detailsTitle": "Book Details",
  "about.detailAuthor": "Author",
  "about.detailFormat": "Format",
  "about.detailFormatVal": "Printed physical book",
  "about.detailShipping": "Shipping",
  "about.detailShippingVal": "Free to Mexico and USA",
  "about.detailQuote": "\"Coherence guarantee: It would be very unusual for a book about extraordinary warranties not to commit to you. If after reading the book you feel it didn't give you at least one clear warranty idea for your business, we'll work with you to directly suggest an applicable proposal for your company.\"",
  "about.detailCta": "Get my Copy",

  // Options for you and your team (purchase cards)
  "options.title": "Options for you and your team",
  "options.bestseller": "BESTSELLER",
  "options.amazonNote": "Also available on",
  "options.bookCard.label": "Physical Book",
  "options.bookCard.subtitle": "One-time investment",
  "options.bookCard.b1": "1 physical copy of the book",
  "options.bookCard.b2": "Free shipping to Mexico and the USA",
  "options.bookCard.b3": "100 warranty examples",
  "options.bookCard.b4": "Practical, straight-to-the-point read",
  "options.bookCard.cta": "Buy Book",
  "options.mentoringCard.badge": "RECOMMENDED",
  "options.mentoringCard.label": "1:1 Mentoring",
  "options.mentoringCard.subtitle": "Strategy session",
  "options.mentoringCard.b1": "45 minutes with Edmundo Treviño",
  "options.mentoringCard.b2": "Diagnosis of your business",
  "options.mentoringCard.b3": "Design of 1-3 warranties",
  "options.mentoringCard.b4": "Optional recording",
  "options.mentoringCard.cta": "Book Mentoring",
  "options.bundleCard.label": "25 Books + Mentoring Bundle",
  "options.bundleCard.subtitle": "For teams",
  "options.bundleCard.b1": "25 physical copies",
  "options.bundleCard.b2": "Strategic mentoring / talk",
  "options.bundleCard.b3": "Work on real cases",
  "options.bundleCard.b4": "Q&A with your team",
  "options.bundleCard.cta": "Get Bundle",
  "options.bundleCard.whatsappMessage": "Hi, I'm interested in getting a corporate bundle of books and mentoring for my company.",

  // Newsletter
  "newsletter.badge": "Edmundo Treviño's Newsletter",
  "newsletter.title": "Get new warranties and business opportunities",
  "newsletter.desc": "Subscribe to receive every new extraordinary warranty, business ideas in the USA, and investment opportunities directly in your inbox.",
  "newsletter.namePlaceholder": "Your name (optional)",
  "newsletter.emailPlaceholder": "you@email.com",
  "newsletter.submit": "Subscribe",
  "newsletter.noSpam": "No spam. You can unsubscribe at any time.",
  "newsletter.success": "Done! Check your email to confirm your subscription.",
  "newsletter.alreadySubscribed": "You're already subscribed. Thanks for your interest!",
  "newsletter.reactivated": "Welcome back! Your subscription has been reactivated.",
  "newsletter.subscribeSuccess": "Successfully subscribed! You'll receive our next publications.",
  "newsletter.subscribeError": "Error subscribing. Please try again.",
  "newsletter.emailRequired": "Please enter your email.",
  "newsletter.subscribed": "Subscribed!",
  "newsletter.inlineTitle": "Don't miss any warranty",
  "newsletter.inlineDesc": "Receive new extraordinary warranties, business ideas in the USA, and investment opportunities.",
  "newsletter.inlineSuccess": "Successfully subscribed!",
  "newsletter.compactTitle": "Newsletter",
  "newsletter.compactDesc": "Warranties, US business & investment.",

  // Footer
  "footer.brand": "Extraordinary Warranties",
  "footer.brandDesc": "100 warranty ideas to differentiate your business. A project by Edmundo Treviño.",
  "footer.navigation": "Navigation",
  "footer.edmundo": "Edmundo Treviño",
  "footer.personalSite": "Personal Website",
  "footer.buyBook": "Buy the Book",
  "footer.bookConsulting": "Book a Session",
  "footer.copyright": "Extraordinary Warranties by Edmundo Treviño. All rights reserved.",

  // Admin (kept mostly in Spanish since it's for the owner)
  "admin.title": "Admin Panel",
  "admin.desc": "Manage the blog and moderate reader ideas.",
  "admin.restricted": "Restricted Access",
  "admin.restrictedDesc": "Log in as admin to access the panel.",
  "admin.login": "Log In",
  "admin.noPermission": "No Permissions",
  "admin.noPermissionDesc": "You don't have admin permissions.",
  "admin.tabBlog": "Blog",
  "admin.tabIdeas": "Reader Ideas",
  "admin.tabSubscribers": "Subscribers",

  // Industries
  "industry.automotive": "Automotive",
  "industry.restaurants": "Restaurants & Hospitality",
  "industry.health": "Health & Clinics",
  "industry.education": "Education",
  "industry.technology": "Technology",
  "industry.ecommerce": "E-commerce",
  "industry.professional": "Professional Services",
  "industry.franchises": "Franchises",
  "industry.construction": "Construction",
  "industry.retail": "Retail",
  "industry.memberships": "Memberships",
  "industry.consulting": "Consulting",
  "industry.other": "Other",

  // 404
  "notFound.title": "Page not found",
  "notFound.desc": "The page you're looking for doesn't exist.",
  "notFound.home": "Back to home",
};

export const dictionaries: Record<Locale, Record<string, string>> = { es, en };

